import React, {Component} from 'react';
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import { FieldGroup } from '../FieldGroup';
import getFieldFactory from '../../Endpoint/FieldFactory';
import FieldGroups from '../FieldGroups';

class Headers extends Component {

	render() {

		const newCustomField = {
			name:   'request-header',
			label:  'Request Header',
			fields: [
				getFieldFactory().getSourceField(), getFieldFactory().getValueInputType(), {
					id:        'requestHeader',
					inputType: 'input',
					value:     '',
					label:     'Header name',
					dynamic:   false,
				}, getFieldFactory().getParametersField(),
				getFieldFactory().getDynamicField()
			],
		};


		const {addSubField, group} = this.props;

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

					<React.Fragment>
						<h3>Request Headers</h3>
						<p>Here you can define headers for your request. If you need to pass authentication headers then here is the place.</p>

						<ParametersNotice parameters={endpoint.parameters}/>

						<button onClick={() => addSubField(endpointId, [ newCustomField ], currentItem, group, action)} className="button-secondary">
							Add a request header
						</button>

						<FieldGroups group={group}/>

					</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Headers);
